const getCurrentStep = (dialogContentEl) => +dialogContentEl.getAttribute('data-step');

const calculateNextStep = (step, dialogContentEl) => {
  switch (step) {
    case 'next':
      return getCurrentStep(dialogContentEl) + 1;
    case 'prev':
      return getCurrentStep(dialogContentEl) - 1;
    default:
      return step;
  }
};

const placeholders = {
  0: 'Type or choose your vehicle make',
  1: 'Type or choose your vehicle year',
  default: 'Type or choose your vehicle model',
};

const changePlaceholderText = (step) => {
  const placeholderText = placeholders[step] || placeholders.default;

  const searchInput = window.document.querySelector('#cm_filter-input-vehicleTiles');
  searchInput.setAttribute('placeholder', placeholderText);
};

export const changeStep = (step) => {
  const dialogContentEl = window.document.querySelector('.dialog-container');
  if (!dialogContentEl) {
    return;
  }

  const changedStep = calculateNextStep(step, dialogContentEl);
  dialogContentEl.setAttribute('data-step', changedStep);
  changePlaceholderText(changedStep);
};
